/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { Service } from '@roc/client-portal-shared/services';

const url = {
  GET_VALUATION_INFO: '/api/v1/roc-valuation/public/getPaymentInfo',
  SAVE_PAYMENT_POINT_OF_CONTACT: '/api/v1/roc-valuation/public/paymentPointOfContact',
  GENERATE_VALUATION_PAYMENT_DOCUMENT:
    '/nportal/rest/pub/signing/generateValuationPaymentDocument',
};

export class ValuationPaymentService extends Service {
  /** Resolves with the payment info the signed link token grants access to. */
  getValuationInfo(token: string) {
    return this.get(url.GET_VALUATION_INFO, { token });
  }

  savePaymentPointOfContact(request) {
    return this.put(url.SAVE_PAYMENT_POINT_OF_CONTACT, request);
  }

  generateValuationPaymentDocument(request) {
    return this.post(`${url.GENERATE_VALUATION_PAYMENT_DOCUMENT}`, request);
  }

}
